module.exports = __webpack_public_path__ + "img/charcoal_bronze.14e2bb19.jpg";